import styled from "styled-components";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import {
	formatColor,
	getAnchorStyles,
} from "@website-builder/utilities/utils/DesignUtils.js";

export const PortfolioShowcaseWrapper = styled.div`
	background-color: ${({ color }) =>
		color ? formatColor(color) : "var(--theme-primary)"};
	padding: 5rem 0;
	${({ isDarkBackground }) =>
		isDarkBackground
			? `
    color: var(--primary-neutral-white);`
			: ""}
	.title {
		margin: 1rem 0;
	}
	.description {
		margin: 1.5rem 0;
		& div p {
			font-family: var(--desktop-body-s-regular-ff) !important;
		}
	}
	.card-container {
		padding: 2rem 1.5rem;
		margin: 3.5rem 6rem 5rem;
	}
	.left-section {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: flex-start;
	}
	a.link-mobile {
		display: none;
	}
	button.link-desktop {
		display: flex;
		&:hover:enabled,
		&:focus:enabled {
			color: ${({ isDarkBackground }) =>
				isDarkBackground
					? "var(--primary-neutral-white)"
					: "var(--primary-neutral-nightshade-800)"} !important;
		}
	}
	.portfolio-container {
		margin: 0;
	}
	.portfolio-grid-col:nth-child(odd) {
		border-right: 1px solid var(--secondary-gray-medium);
	}
	.portfolio-container > div {
		display: flex;
		width: 100%;
	}
	.portfolio-header-grid {
		margin: 0;
		& .header {
			margin: 8px 0 24px 0;
		}
	}
	.item-description div p {
		font-family: var(--desktop-body-s-regular-ff) !important;
	}
	li.list-item {
		margin: 1.5rem 0;
	}
	.link {
		margin-top: 1.5rem;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 2.5rem 0 0;
		.top-content {
			padding: 0 1.5rem;
			margin: 0;
		}
		.top-content,
		.portfolio-header-grid,
		.portfolio-container {
			margin: 0;
		}
		.list-header {
			display: none;
		}
		.left-section {
			align-items: center;
			text-align: center;
		}
		.card-container {
			margin: 3.5rem 0 0;
		}
		.portfolio-grid-col {
			&:nth-child(odd) {
				border-right: 0px;
			}
			&:not(:last-child) {
				border-bottom: 1px solid var(--secondary-gray-medium);
			}
		}
		button.link-desktop {
			display: none;
		}
		a.link-mobile {
			display: flex;
			margin: 1.5rem auto 0 auto;
		}
		.link-mobile-container {
			display: flex;
			justify-content: center;
		}
		.portfolio-container > div {
			grid-column-start: 1;
			grid-column-end: 7;
		}
		.portfolio-container > div:nth-child(even) {
			grid-column-start: 1;
			grid-column-end: 7;
		}
		.portfolio-container > div:not(:last-child) {
			padding-bottom: 1.5rem;
		}
		.portfolio-header-grid {
			text-align: center;
		}
	}
`;
export const ListItemWrapper = styled.div`
	text-align: start;
	.item-description {
		margin: 0;
	}
	.list-item {
		align-items: center;
	}

	.rich-text-wrapper {
		${({ isDarkBackground }) => getAnchorStyles(isDarkBackground)}
	}
`;
